import { render } from "./sim-hlr-info.vue?vue&type=template&id=7fb0a44f&scoped=true"
import script from "./sim-hlr-info.vue?vue&type=script&lang=js"
export * from "./sim-hlr-info.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7fb0a44f"

export default script